if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.bindThumbnailsClick = this.onThumbnailsClick.bind(this);
        this.bindOnMediaClick = this.onMediaClick.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        this.thumbnailsWrapper = this.querySelector('.product-media-modal__thumbnails');
        this.thumbnails = this.querySelectorAll('.thumbnails-wrapper');
        this.medias = this.querySelectorAll('.product-media-modal__image');
        this.thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', this.bindThumbnailsClick));
        this.scrollContainer = this.querySelector('.product-media-modal__thumbnails');
        this.allFirstItems = this.querySelectorAll('.thumbnails-wrapper');
        this.setThumbnailsMouseDrag();

        this.medias.forEach((media) => {
          media.addEventListener('click', this.bindOnMediaClick);
        });
      }

      show(opener) {
        super.show(opener);
        this.medias.forEach((media) => media.classList.add('no-transition'));
        this.thumbnails.forEach((thumbnail) => thumbnail.classList.add('no-transition'));
        this.showActiveMedia();
        setTimeout(() => {
          this.medias.forEach((media) => media.classList.remove('no-transition'));
          this.thumbnails.forEach((thumbnail) => thumbnail.classList.remove('no-transition'));
        }, 301);
        this.setThumbnailActive(opener);
      }

      hide() {
        super.hide();
        this.classList.add('closed');
        setTimeout(() => {
          this.removeAttribute('open');
          if (this.setOverflowHidden)
            if (
              !document.body.querySelector('.header__search-predictive-search details[open]') &&
              !document.body.querySelector('quick-add-modal[open]') &&
              !document.body.querySelector('modal-dialog[open]')
            )
              document.body.classList.remove('overflow-hidden');
          document.body.dispatchEvent(new CustomEvent('modalClosed'));
          replayAllMedia();
          this.classList.remove('closed');
        }, this.hideDelay);
      }

      showActiveMedia() {
        this.medias.forEach((media) => {
          media.classList.remove('active');
        });

        const activeMedia = Array.from(this.medias).find(
          (media) => media.getAttribute('data-modal-media-id') === this.openedBy.getAttribute('data-modal-media-id')
        );

        if (!activeMedia.classList.contains('enable-zoom')) {
          this.classList.remove('full-zoom__enabled');
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      onThumbnailsClick(event) {
        event.preventDefault();

        const mediaId = event.currentTarget.getAttribute('data-modal-media-id');

        this.querySelectorAll('.product-media-modal__image').forEach((image) => image.classList.remove('active'));

        const selectedMedia = this.querySelector(`.product-media-modal__image[data-modal-media-id="${mediaId}"]`);
        if (selectedMedia) {
          selectedMedia.classList.add('active');
          if (!selectedMedia.classList.contains('enable-zoom')) {
            this.classList.remove('full-zoom__enabled');
          }
        }
        this.setThumbnailActive(event.currentTarget);
      }

      setThumbnailActive(trigger) {
        this.thumbnails.forEach((thumbnail) => {
          if (thumbnail.getAttribute('data-modal-media-id') === trigger.getAttribute('data-modal-media-id')) {
            thumbnail.classList.add('active');
          } else {
            thumbnail.classList.remove('active');
          }
        });
        const activeThumbnail = this.querySelector('.thumbnails-wrapper.active');
        if (!activeThumbnail) return;

        const scrollOffset = 20;
        const activeThumbnailWidth = activeThumbnail.clientWidth;
        const activeThumbnailHeight = activeThumbnail.clientHeight;
        const activeThumbnailOffsetLeft = activeThumbnail.offsetLeft;
        const activeThumbnailOffsetTop = activeThumbnail.offsetTop;
        const wrapperScrollLeft = this.thumbnailsWrapper.scrollLeft;
        const wrapperScrollTop = this.thumbnailsWrapper.scrollTop;
        const wrapperClientWidth = this.thumbnailsWrapper.clientWidth;
        const wrapperClientHeight = this.thumbnailsWrapper.clientHeight;

        if (activeThumbnailOffsetLeft < wrapperScrollLeft) {
          this.thumbnailsWrapper.scrollTo({
            left: activeThumbnailOffsetLeft - scrollOffset,
            behavior: 'smooth',
          });
        } else if (activeThumbnailOffsetLeft + activeThumbnailWidth > wrapperScrollLeft + wrapperClientWidth) {
          this.thumbnailsWrapper.scrollTo({
            left: activeThumbnailOffsetLeft + activeThumbnailWidth - wrapperClientWidth + scrollOffset,
            behavior: 'smooth',
          });
        } else if (activeThumbnailOffsetTop < wrapperScrollTop) {
          this.thumbnailsWrapper.scrollTo({
            top: activeThumbnailOffsetTop - scrollOffset,
            behavior: 'smooth',
          });
        } else if (activeThumbnailOffsetTop + activeThumbnailHeight > wrapperScrollTop + wrapperClientHeight) {
          this.thumbnailsWrapper.scrollTo({
            top: activeThumbnailOffsetTop + activeThumbnailHeight - wrapperClientHeight + scrollOffset,
            behavior: 'smooth',
          });
        }
      }

      setThumbnailsMouseDrag() {
        if (!this.scrollContainer) return;

        let isDown = false;
        let startX = 0;
        let startY = 0;
        let scrollLeft = 0;
        let scrollTop = 0;

        const mouseDown = (event) => {
          event.preventDefault();
          this.scrollContainer.classList.add('grabbing');
          isDown = true;
          startX = event.pageX - this.scrollContainer.offsetLeft;
          startY = event.pageY - this.scrollContainer.offsetTop;
          scrollLeft = this.scrollContainer.scrollLeft;
          scrollTop = this.scrollContainer.scrollTop;

          this.scrollContainer.addEventListener('mousemove', mouseMove, { passive: false });
          this.scrollContainer.addEventListener('mouseup', mouseUp, { passive: false });
          this.scrollContainer.addEventListener('mouseleave', mouseUp, { passive: false });
        };

        const mouseMove = (event) => {
          event.preventDefault();
          if (!isDown) return;

          this.scrollContainer.classList.add('moving');

          const x = event.pageX - this.scrollContainer.offsetLeft;
          const walkX = x - startX;
          this.scrollContainer.scrollLeft = scrollLeft - walkX;

          const y = event.pageY - this.scrollContainer.offsetTop;
          const walkY = y - startY;
          this.scrollContainer.scrollTop = scrollTop - walkY;
        };

        const mouseUp = () => {
          isDown = false;
          this.scrollContainer.classList.remove('grabbing');
          this.scrollContainer.classList.remove('moving');

          this.scrollContainer.removeEventListener('mousemove', mouseMove, { passive: false });
          this.scrollContainer.removeEventListener('mouseup', mouseUp, { passive: false });
          this.scrollContainer.removeEventListener('mouseleave', mouseUp, { passive: false });
        };

        this.scrollContainer.addEventListener('mousedown', mouseDown, { passive: false });
      }

      onMediaClick(event) {
        const media = event.currentTarget;
        if (media.classList.contains('enable-zoom')) {
          this.classList.toggle('full-zoom__enabled');
          const mediaModalWrapper = document.querySelector('.product-media-modal__images');
          const clickPercentageOfViewportHeight = event.clientY / window.innerHeight;
          const scrollPosition = media.offsetHeight * clickPercentageOfViewportHeight * 0.75;
          mediaModalWrapper.scrollTop = scrollPosition;
        } else {
          this.classList.remove('full-zoom__enabled');
        }
      }
    }
  );
}
